<template>
  <el-card>
    <el-form-item>
      <el-button @click="printPreview" :loading="loading">预览</el-button>
      <el-button @click="print" :loading="loading">打印</el-button>
      <KfMessage ref="commitMessage"></KfMessage>
    </el-form-item>
    <el-form-item>
      <div id="divPrint" class="preview-img">
        <img :src="imageBase64" :style="'width:' + imageWidth + 'px; height:' + imageHeight + 'px;'"
             v-if="imageBase64.length > 0">
      </div>
    </el-form-item>
  </el-card>
</template>

<script>
export default {
  name: "BusGlassBatchPrint",

  props: {
    parentData: {
      type: Object,
      default() {
        return {}
      }
    },
  },

  data() {
    return {
      imageBase64: '',
      imageHeight: 320,
      imageWidth: 400,
      loading: false,
      printDto: {},
    }
  },
  methods: {

    async printPreview() {
      this.imageBase64List = []
      this.loading = true;
      console.log(this.parentData)

      await this.$axios.post('bus/print/createBoLiBatchLabel', this.parentData).then(response => {
        this.loading = false;
        let res = response.data

        if (res.code !== 0) {
          return this.$message.error(res.message);
        } else {
          this.printDto = res.data;
          for (let i = 0; i < res.data.length; i++) {
            this.imageBase64 = res.data[i].imageBase64 || '';
            if (this.imageBase64.length > 0) {
              this.imageBase64 = "data:image/jpeg;base64," + this.imageBase64;
              this.imageBase64List.push(this.imageBase64);
            }
          }
        }

      }, error => {
        this.loading = false;
        this.$refs.commitMessage.showError(`生成打印图像失败，${error.message}`);
      })
    },
    async print() {
      await this.printPreview();
      this.printDiv()
      /*for (let i = 0; i < this.imageBase64List.length; i++) {
        if (!this.imageBase64List[i] || this.imageBase64List[i].length === 0) {
          return;
        }

        this.loading = true;
        if (i === this.imageBase64List.length - 1) {
          this.updatePrintedCount();
        }
        //调用本地打印服务器
        var printParams = {printer_name: this.printDto[i].printerName, zpl: this.printDto[i].zpl};
        await axios.post(process.env.VUE_APP_PRINT_URL, printParams).then(response => {
          this.loading = false;
          let res = response.data
          console.log(res)

          this.parentData.boLiNo = this.printDto[i].boLiNo
          this.parentData.printed_count = this.parentData.printed_count + 1;
          this.addPrintRecord();
          if (i === this.imageBase64List.length - 1) {
            this.updatePrintedCount();
          }
        }, error => {
          this.loading = false;
          this.$message.error(`提交打印失败，${error.message}`);
        })
      }*/
      this.params.num = 0
    },
    async updatePrintedCount() {
      await this.$axios.post('bus/print/updatePrintedCount', this.params).then(response => {
        let res = response.data
        console.log(res)
      })
    },
    async addPrintRecord() {
      await this.$axios.post('bus/print/addPrintRecord', this.parentData).then(response => {
        let res = response.data
        console.log(res)
      })
    },
    printDiv() {
      //打印div
      //打开一个新窗口newWindow
      var newWindow = window.open("打印窗口", "_blank");
      //要打印的div的内容
      var docStr = document.getElementById("divPrint").innerHTML;
      //打印内容写入newWindow文档
      newWindow.document.write(docStr);
      //关闭文档
      newWindow.document.close();

      //调用打印机
      setTimeout(() => {
        newWindow.print();
        newWindow.close();
      }, 50);

      return false;
    },
  }
}
</script>

<style scoped>
.preview-img {
  width: 402px;
  height: 322px;
  border: solid 1px #a1a1a1;
}
</style>
